/* @flow */
import Link from 'components/Link.jsx';
import React from 'react';

import cx from 'classnames';

class ReportChatModalOption extends React.Component {
  static propTypes = {
    disabled: React.PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
  };

  render() {
    return (
      <Link
        {...this.props}
        bar
        color="pitch"
        className={cx({
          'ReportChatModal-button': true,
          'ReportChatModal-button-disabled': this.props.disabled,
        }, this.props.className)}>
        {this.props.children}
      </Link>
    );
  }
}

export default ReportChatModalOption;



// WEBPACK FOOTER //
// ./src/chat/components/ReportChatModalOption.jsx